import { Container } from 'inversify'

import { HandballIncidentId } from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindAssignableIncidentConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.AssignableIncidentsConfiguration)
    .toDynamicValue(() => {
      return {
        [HandballIncidentId.Goal]: {
          participants: { main: 'Scorer' },
        },
        [HandballIncidentId.MissedThrow]: {
          participants: { main: 'Taken by' },
        },
        [HandballIncidentId.ThrowSaved]: {
          participants: { main: 'Taken by' },
        },
        [HandballIncidentId.ThrowBlocked]: {
          participants: { main: 'Taken by' },
        },
        [HandballIncidentId.Turnover]: {
          participants: { main: 'Player' },
        },
        [HandballIncidentId.Steal]: {
          participants: { main: 'Player', secondary: 'Steal from' },
          participantsConfiguration: { secondary: { loadOppositeTeam: true } },
        },
        [HandballIncidentId.YellowCard]: {
          participants: { main: 'Player' },
        },
        [HandballIncidentId.RedCard]: {
          participants: { main: 'Player' },
        },
        [HandballIncidentId.BlueCard]: {
          participants: { main: 'Player' },
        },
        [HandballIncidentId.Penalty]: {
          participants: { main: 'Penalty taker' },
        },
        [HandballIncidentId.MissedPenalty]: {
          participants: { main: 'Penalty taker' },
        },
        [HandballIncidentId.PenaltySaved]: {
          participants: { main: 'Penalty taker' },
        },
        [HandballIncidentId.TwoMinuteSuspension]: {
          participants: { main: 'Penalty taker' },
        },
      }
    })
    .inSingletonScope()
}
